
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"17","height":"17","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"clip-path"}},[_c('path',{attrs:{"id":"Clip_2","d":"M0 0h10v7H0z","fill":"none"}})])]),_c('g',{attrs:{"id":"Group_1216","transform":"translate(-1128 -99)"}},[_c('circle',{attrs:{"id":"Aantal_artikelen_BG","cx":"8.5","cy":"8.5","r":"8.5","transform":"translate(1128 99)","fill":"#68b612"}}),_c('g',{attrs:{"id":"Check","transform":"translate(1132 104)"}},[_c('path',{attrs:{"id":"Clip_2-2","d":"M0 0h10v7H0z","fill":"none"}}),_c('g',{attrs:{"id":"Check-2","clip-path":"url(#clip-path)"}},[_c('path',{attrs:{"id":"Fill_1","d":"M9.076.1L3.8 5.475.923 2.549a.344.344 0 00-.493 0l-.33.335a.359.359 0 000 .5L3.552 6.9a.345.345 0 00.493 0L9.9.94a.359.359 0 000-.5L9.569.1a.344.344 0 00-.493 0","fill":"#fff"}})])])])])
          )
        }
      }
    